import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { ExtendableMutationOptions } from 'shared/api/api.types'
import { authApi } from 'shared/api/auth'

import {
  RegisterErrorResponse,
  RegisterRequest,
  RegisterResponse
} from './register.types'

export const register = async (request: RegisterRequest) => {
  const response = await authApi.post<RegisterResponse>(
    '/innos/register',
    request
  )

  return response.data
}

export const useRegisterMutation = (
  options?: ExtendableMutationOptions<
    RegisterResponse,
    RegisterRequest,
    AxiosError<RegisterErrorResponse>
  >
) => {
  return useMutation({
    mutationFn: register,
    ...options
  })
}
